export const removeAtIndex = <T>(array: T[], targetIndex: number): T[] =>
  array.filter((_, index) => index !== targetIndex)
